import { FormattedMessage } from 'react-intl';
import React from 'react';
import { CheckboxFilter } from 'components/shared/filters/CheckboxFilter';
import { FILTERS_NAMES, FILTERS } from 'config/certificate';
import { TRANSLATED_CERTIFICATE_FILTER_STATUSES } from 'config/constants';

function CertificatesTableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th>
          <FormattedMessage id="components.pages.management.manageCertificates.id" />
        </th>
        <th
          className="sort"
          data-sort="user_id"
          scope="col"
          onClick={() => props.applySort('user_id')}
        >
          <FormattedMessage id="components.pages.management.manageCertificates.user" />
        </th>
        <th
          className="sort"
          data-sort="order.organization_name.belongs_to"
          scope="col"
          onClick={() => props.applySort('order.organization_name.belongs_to')}>
          <FormattedMessage id="components.pages.management.manageCertificates.organization" />
        </th>
        <th
          data-sort="order-id"
          scope="col"
          onClick={() => props.applySort('id')}>
          <FormattedMessage id="components.pages.management.manageCertificates.order" />
        </th>
        <th>
          <FormattedMessage id="components.pages.management.manageCertificates.serial_number" />
        </th>
        <th>
          <FormattedMessage id="components.pages.management.manageCertificates.status" />
          {props.applyFilters && props.filters ? (
            <CheckboxFilter
              index={0}
              applyFilters={props.applyFilters}
              filters={props.filters.statuses}
              filterKey={FILTERS.statuses}
              filterName={FILTERS_NAMES.statuses}
              list={TRANSLATED_CERTIFICATE_FILTER_STATUSES}
            />
          ) : null}
        </th>
        <th>
          <FormattedMessage id="components.pages.management.manageCertificates.created_at" />
        </th>
        <th>
          <FormattedMessage id="components.pages.management.manageCertificates.expires_at" />
        </th>
        <th scope="row" className="w-10">
          <FormattedMessage id="components.pages.clients.clientsTable.table.actions" />
        </th>
      </tr>
    </thead>
  )
}

export { CertificatesTableHead }
